import { render, staticRenderFns } from "./ModalEditProjectUser.vue?vue&type=template&id=1146a8a9&"
import script from "./ModalEditProjectUser.vue?vue&type=script&lang=js&"
export * from "./ModalEditProjectUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports